import { ListPlusIcon as PhosphorListPlusIcon } from "@phosphor-icons/react/dist/ssr/ListPlus";

import { createAppIcon } from "@/components/createAppIcon";

export const AddToLibraryIcon = /* @__PURE__ */ createAppIcon(PhosphorListPlusIcon);
export const AddToPlaylistIcon = /* @__PURE__ */ createAppIcon(PhosphorListPlusIcon);
